import { Component, OnInit, AfterViewInit, OnDestroy, Inject, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import * as AOS from 'aos';

@Component({
    selector: 'app-home',
    imports: [],
    templateUrl: './home.component.html',
    styleUrls: ['./home.component.scss']
})
export class HomeComponent implements OnInit, AfterViewInit, OnDestroy {
  private intervalId: any;

  constructor(@Inject(PLATFORM_ID) private platformId: Object) {}

  ngOnInit() {
    if (isPlatformBrowser(this.platformId)) {
      AOS.init();
    }
  }

  ngAfterViewInit() {
    if (isPlatformBrowser(this.platformId)) {
      this.startAnimation();
    }
  }

  ngOnDestroy() {
    if (this.intervalId) {
      clearInterval(this.intervalId);
    }
  }

  startAnimation() {
    if (isPlatformBrowser(this.platformId)) {
      const steps = document.querySelectorAll('.step-circle, .step-circle2');
      const lines = document.querySelectorAll('.step-line');
      let currentStep = 0;
  
      this.intervalId = setInterval(() => {
        steps.forEach((step, index) => {
          if (index < currentStep) {
            step.classList.add('left');
            step.classList.remove('right', 'active');
          } else if (index === currentStep) {
            step.classList.add('active');
            step.classList.remove('left', 'right');
          } else {
            step.classList.add('right');
            step.classList.remove('left', 'active');
          }
        });
  
        lines.forEach((line, index) => {
          if (index < currentStep) {
            line.classList.add('left');
            line.classList.remove('right', 'active');
          } else if (index === currentStep) {
            line.classList.add('active');
            line.classList.remove('left', 'right');
          } else {
            line.classList.add('right');
            line.classList.remove('left', 'active');
          }
        });
  
        currentStep = (currentStep + 1) % steps.length;
      }, 2000); // Cambia de paso cada 2 segundos
    }
  }
}

